import { ContentType } from 'enums';

export default function streamSubtitle({ authTypes = [], content: { type, subtitle = '' } }) {
    // no subtitle with non-auth vod
    if (type === ContentType.VOD && authTypes.length === 0) {
        return null;
    }

    return subtitle;
};



// WEBPACK FOOTER //
// ./app/lib/format/streamSubtitle.js